<p-confirmDialog [visible]="showDialog" [style]="{ height: '100vh', width: '95vw' }"  [closable]="false"
[closeOnEscape]="false" [baseZIndex]="10000"
>
  <ng-template pTemplate="header">
    <h3 class="color-secondary text-center w-full">Información</h3>
  </ng-template>
</p-confirmDialog>
